import { PlusOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import PropTypes from 'prop-types'
import { ButtonCommon, PopoverCommon } from 'src/common'
import { CollapseSingleCommon } from 'src/common/CollapseSingleCommon/CollapseSingleCommon'
import { FormAddMeaningItem } from '../FormAddMeaningItem/FormAddMeaningItem'
import MeaningItem from '../MeaningItem/MeaningItem'
import './DefinitionContent.scss'

export const DefinitionContent = ({ word, def, isTermEmpty, lang }) => {
	const hasWordTypeSections =
		(def?.wordTypes || []).length > 0 ||
		(def?.termWordTypes || []).length > 0

	return (
		<section className="u-definition-from-dictionary u-custom-scrollbar">
			{def && hasWordTypeSections && (
				<div className="u-row-right definition-content__toolbar">
					<PopoverCommon
						content={
							<FormAddMeaningItem lang={lang} skipTypeDefault />
						}
						trigger="click"
					>
						<ButtonCommon
							icon={<PlusOutlined />}
							size="small"
							ghost
							type="primary"
							title="Opens a form where you choose part of speech (noun, verb, adjective, …)"
						>
							Add definition
						</ButtonCommon>
					</PopoverCommon>
				</div>
			)}
			{/* First entry when the word has no POS blocks yet */}
			{def && !hasWordTypeSections && (
				<div className="u-row-right">
					<PopoverCommon
						content={
							<FormAddMeaningItem
								initialTypeID={
									def?.wordTypes && def?.wordTypes[0]?.id
								}
								lang={lang}
							/>
						}
						trigger="click"
					>
						<ButtonCommon
							icon={<PlusOutlined />}
							size="small"
							ghost
							type="primary"
						>
							Add meaning
						</ButtonCommon>
					</PopoverCommon>
				</div>
			)}
			{def &&
				(def.wordTypes || []).length > 0 &&
				def.wordTypes.map(wordType => (
					<CollapseSingleCommon
						key={wordType.type}
						header={wordType.type || 'Dịch'}
					>
						<div>
							<div className="u-row-right">
								<PopoverCommon
									content={
										<FormAddMeaningItem
											initialTypeID={wordType.id}
											lang={lang}
										/>
									}
									trigger="click"
								>
									<ButtonCommon
										icon={<PlusOutlined />}
										size="small"
										ghost
										type="primary"
										title={`Add another sense for “${wordType.type || 'this type'}” (you can still change type in the form)`}
									>
										Add ({wordType.type || 'type'})
									</ButtonCommon>
								</PopoverCommon>
							</div>

							<div className="suggest-group">
								<ul className="list-group">
									{wordType.meanings &&
										wordType.meanings.map(item => (
											<MeaningItem
												key={item.definition}
												word={word}
												id={item.id}
												definition={item.definition}
												examples={item.examples}
												lang={lang}
											/>
										))}
								</ul>
							</div>
						</div>
					</CollapseSingleCommon>
				))}
			{def && (def.termWordTypes || []).length > 0 && (
				<>
					{/* TODO: translate */}
					<div className="def-title">Chuyên ngành</div>

					{def.termWordTypes.map(wordType => (
						<CollapseSingleCommon
							key={wordType.type}
							header={wordType.type}
							isOpen={false}
						>
							<div>
								<div className="u-row-right">
									<PopoverCommon
										content={
											<FormAddMeaningItem
												initialTypeID={wordType.id}
												lang={lang}
											/>
										}
										trigger="click"
									>
										<ButtonCommon
											icon={<PlusOutlined />}
											size="small"
											ghost
											type="primary"
											title={`Add meaning under “${wordType.type}”`}
										>
											Add ({wordType.type || 'type'})
										</ButtonCommon>
									</PopoverCommon>
								</div>
								<div className="suggest-group">
									<ul className="list-group">
										{wordType.meanings &&
											wordType.meanings.map(item => (
												<MeaningItem
													key={item.definition}
													word={word}
													id={item.id}
													definition={item.definition}
													examples={item.examples}
													lang={lang}
												/>
											))}
									</ul>
								</div>
							</div>
						</CollapseSingleCommon>
					))}
				</>
			)}

			{(!def ||
				(def.wordTypes || []).length +
					(def.termWordTypes || []).length ===
					0) && (
				<Empty description={isTermEmpty ? 'Empty' : undefined} />
			)}
		</section>
	)
}

DefinitionContent.propTypes = {
	definitionUser: PropTypes.string,
	def: PropTypes.any,
	onAddToDefinition: PropTypes.func,
	onRemoveFromDefinition: PropTypes.func,
}

export default DefinitionContent
